import { useGameStoreApi } from "#/game/GameStoreProvider";
import { useGameHotkeys } from "#/game/hooks/useGameHotkeys";
import { canEndTurnFromState, canUndoFromState } from "#/game/store/selectors";

export function usePlayMapGameHotkeys({ onEndTurn }: { onEndTurn: () => void | Promise<void> }) {
  const api = useGameStoreApi();
  useGameHotkeys({
    canInteract: () => {
      const s = api.getState();
      return (
        s.localState.status === "in_progress" && !s.isSubmitting && !s.animation && !s.aiPlayback
      );
    },
    canConfirmSelection: () => {
      const mode = api.getState().selection.mode;
      return (
        mode === "confirm-attack" ||
        mode === "confirm-capture-reset" ||
        mode === "move-preview" ||
        mode === "unit"
      );
    },
    onConfirmSelection: () => {
      const s = api.getState();
      const { selection } = s;
      if (selection.mode === "confirm-attack") {
        s.confirmAttack();
        return;
      }
      if (selection.mode === "confirm-capture-reset") {
        s.confirmCaptureReset();
        return;
      }
      if (selection.mode === "move-preview") {
        s.selectTile(selection.destination);
        return;
      }
      if (selection.mode === "unit") {
        const unit = s.localState.units.find((u) => u.id === selection.unitId);
        if (unit) s.selectTile(unit.pos);
      }
    },
    canUndo: () => canUndoFromState(api.getState()),
    canEndTurn: () => canEndTurnFromState(api.getState()),
    onCycleUnmovedUnit: () => api.getState().cycleUnmovedUnit(),
    onUndo: () => api.getState().undoLastMove(),
    onEndTurn,
  });
}
